import React, {useContext} from 'react'
import classes from './ImageSection.module.scss'
import logo from './images/logoWhite.png'
import blurLogo from './images/pasha-blur.svg'
import { Text, LanguageContext } from '../../containers/Language';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
  } from "react-router-dom";

const ImageSection = () => {

    const {dictionary} = useContext(LanguageContext);

    return (
        <div className={classes.imageSection}>
            <div className={classes.left}>
            </div>
            <div className={classes.right}></div>

            <div className={classes.innerSection}>
                <div className='container'>
                    <div className={classes.innerLeft}>
                        <img src={logo} alt='Logo' />
                        <p><Text tid="HYS"/></p>
                        <h1 dangerouslySetInnerHTML={{__html: dictionary.HYS_INFO}}></h1>

                    
                        <Router>
                            <Link to={{ pathname: "https://mylife.az/onlineapp" }} 
                                target="_blank">
                                <button className={`btn btn-primary btn-lg ${classes.apply}`}><Text tid="APPLY" /> <i className="fal fa-long-arrow-right"></i></button>
                            </Link>
                        </Router>
                    
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ImageSection
